import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import pushGA from '../../services/utils/pushGA';
import EmailField from '../../components/common/EmailField';
import { Checkbox } from '@s7/ui-kit';
import Preloader from '../../components/common/Preloader';

import { injectIntl } from '../../Intl';

import ChevronLeft from '../../assets/images/chevron-left.svg';

import '../../assets/styles/components/subscription.scss';

const reEmail = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-zA-Z]{2,63}(?:\.[a-zA-Z]{2})?)$/;

const mapStateToProps = state => {
    return {
        deviceWidth: state.App.deviceWidth,
        lang: state.App.lang,
    };
};
class Subscription extends Component {
    state = {
        emailValue: '',
        emailError: '',
        confirmCheckbox: this.props.confirmCheckbox,
        emailSubscribe: 'DEFAULT',
        errorCode: '',
        isPreloaderHidden: true,
        subscribeError: ''
    };

    componentDidMount() {
        const { words, getMessage } = this.props;

        getMessage(words, 'com.s7.new.tablo.subscription.error');
        getMessage(words, 'com.s7.new.tablo.subscription.errormore');
        getMessage(words, 'com.s7.component.subscription.success');
        getMessage(words, 'com.s7.index.tablo.validation.empty');
        getMessage(words, 'com.s7.validation.not.use.cyrillic.in.email');
        getMessage(words, 'com.s7.index.tablo.validation.only.email');
        getMessage(words, 'com.s7.header.subscrib.error');
        getMessage(words, 'com.s7.header.subscrib.alreadysubscribed');
        getMessage(words, 'com.s7.header.subscrib.alreadysubscribed.compact');
    }

    renderTrailingButton = () => {
        const { words, getMessage, btnCssClasses } = this.props;
        const { confirmCheckbox } = this.state;

        return (
            <button
                className={classnames({
                    'subscription-form-button': true,
                    [btnCssClasses]: !!btnCssClasses,
                })}
                dangerouslySetInnerHTML={{ __html: getMessage(words, 'com.s7.flight.subscribe.submit') }}
                disabled={!confirmCheckbox}
            />
        );
    };

    renderAgreement = () => {
        const { words, getMessage } = this.props;
        const { confirmCheckbox } = this.state;

        return (
            <div className="input-agreement-check">
                <Checkbox
                    checked={confirmCheckbox}
                    onChange={this.agreementCheck}
                ><span className={'input-agreement-check-text'} dangerouslySetInnerHTML={{ __html: getMessage(words, 'com.s7.subscription.terms.agreed') }}></span></Checkbox>
            </div>
        )
    };

    agreementCheck = async event => {
        const isAgree = event.target.checked;
        const { gaCategory, gaFrom} = this.props;

        this.setState({ confirmCheckbox: isAgree });

        pushGA(
            `PORTAL ${gaCategory} ${gaFrom}`,
            'Click_Terms',
            undefined, {
                eventValue: 0,
                eventInteraction: 0,
                eventUX: undefined,
            }
        );
    };

    handleError = () => {
        this.setState({
            isPreloaderHidden: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    emailSubscribe: 'DEFAULT',
                    isPreloaderHidden: true,
                    subscribeError: '',
                    errorCode: ''
                })
            }, 200)
        });
    };

    handleSubmit = event => {
        const { gaFrom, gaCategory, onSubmit, words, getMessage, compact } = this.props;
        const { emailValue } = this.state;
        const alreadySubscribed = compact ? getMessage(words, 'com.s7.header.subscrib.alreadysubscribed.compact') :
            getMessage(words, 'com.s7.header.subscrib.alreadysubscribed');

        event.preventDefault();
        pushGA(`${gaCategory}`, 'Click Submit', `FROM:${gaFrom}`);

        if (this.validateEmail()) {
            this.setState({ isPreloaderHidden: false });

            onSubmit(emailValue)
                .then(({ data }) => {
                    if (data.errors && data.errors.length > 0 && data.errors[0].explain === 'error/email/wrongroot') {
                        this.setState({
                            emailSubscribe: 'ERROR',
                            isPreloaderHidden: true,
                            subscribeError: getMessage(words, 'com.s7.index.tablo.validation.only.email')
                        });
                        pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};ERROR:server;email:${data.errors[0].explain}`);
                        return;
                    }

                    this.setState({emailSubscribe: 'SUCCESS', isPreloaderHidden: true});
                    pushGA(`${gaCategory}`, 'Submit Success', `FROM:${gaFrom}`);
                })
                .catch(({response}) => {
                    if (response.status === 409) {
                        this.setState({
                            emailSubscribe: 'ERROR',
                            isPreloaderHidden: true,
                            errorCode: 409,
                            subscribeError: alreadySubscribed
                        });
                        pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};ERROR:server;${getMessage(words, 'com.s7.header.subscrib.alreadysubscribed')}`);

                    } else {
                        this.setState({
                            emailSubscribe: 'ERROR',
                            isPreloaderHidden: true,
                            subscribeError: ''
                        });
                        pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};ERROR:server;${getMessage(words, 'com.s7.header.subscrib.error')}`);
                    }
                });
        }
    };

    validateEmail = () => {
        const { words, getMessage, gaFrom, gaCategory } = this.props;
        const { emailValue } = this.state;

        let isValid = true;
        let emailError = '';

        if (!emailValue) {
            emailError = getMessage(words, 'com.s7.index.tablo.validation.empty');
            // pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};TYPE:client;email:${emailError}`);
            isValid = false;
        } else if (/[А-Яа-я]/.test(emailValue)) {
            emailError = getMessage(words, 'com.s7.validation.not.use.cyrillic.in.email');
            // pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};TYPE:client;email:${emailError}`);
            isValid = false;
        } else if (!reEmail.test(emailValue)) {
            emailError = getMessage(words, 'com.s7.index.tablo.validation.only.email');
            // pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};TYPE:client;email:${emailError}`);
            isValid = false;
        }

        if (!isValid) {
            this.setState({ emailError: emailError });
            pushGA(`${gaCategory}`, 'Submit Error', `FROM:${gaFrom};ERROR:client;email:${emailError}`);
        }

        return isValid;
    };

    render() {
        const { words, getMessage, text, deviceWidth, cssClasses, title, titleLevel, dataTest, fullSize, compact } = this.props;
        const { isPreloaderHidden, emailSubscribe, emailValue, emailError, subscribeError, errorCode } = this.state;

        const Tag = titleLevel === 0 ? 'h3' : 'h' + titleLevel;

        return (
            <form
                className={classnames({
                    'subscription-form': true,
                    'subscription-form-compact': compact,
                    [cssClasses]: !!cssClasses,
                })}
                onSubmit={event => this.handleSubmit(event)}
                data-test={dataTest}
            >

                {
                    compact ? <div className={'subscription-form-container-compact'}>
                        <div className={'subscription-form-container-compact-wrap'}>
                            <Tag
                                dangerouslySetInnerHTML={{ __html: title }}
                                className={'subscription-form-compact-title'}
                            />

                            {
                                emailSubscribe !== 'ERROR' && emailSubscribe !== 'SUCCESS' && <p
                                    dangerouslySetInnerHTML={{ __html: text }}
                                    className={'subscription-form-compact-text'}
                                />
                            }

                            {emailSubscribe === 'DEFAULT' && (
                                <div className={'subscription-form-fields'}>
                                    <EmailField
                                        name="email"
                                        classes={{error: 'input__error subscription-form-email-error', root: 'subscription-form-email', input: 'subscription-form-compact-email-input'}}
                                        placeholder={getMessage(words, 'com.s7.form', 'feedback.placeholder.email')}
                                        value={ emailValue }
                                        onChange={ value => {
                                            this.setState({ emailValue: value });
                                        }}
                                        error={ emailError }
                                        required
                                        onFocus={() => this.setState({ emailError: ''})}
                                        on
                                    />

                                    {this.renderAgreement()}

                                    {this.renderTrailingButton()}

                                    <Preloader
                                        isHidden={isPreloaderHidden}
                                        small
                                    />
                                </div>
                            )}

                            {emailSubscribe === 'SUCCESS' && <div
                                className={classnames({
                                    'subscription-form-status': true,
                                    'success': true,
                                    'success-compact': true
                                })}
                            >
                                <span> {getMessage(words, 'com.s7.component.subscription.success')} </span>
                            </div>}

                            <div className={'subscription-form-error-container'}>
                                {emailSubscribe === 'ERROR' && <div
                                    className={classnames({
                                        'subscription-form-status': true,
                                        'error': true,
                                        'error-compact': true
                                    })}
                                >
                                    <span>
                                        {isEmpty(subscribeError) ?
                                            <Fragment>
                                                {getMessage(words, 'com.s7.new.tablo.subscription.error')}
                                                <a className={'subscription-form-status-error-link'}
                                                   onClick={this.handleError}>
                                                   {getMessage(words, 'com.s7.new.tablo.subscription.errormore')}
                                                </a>
                                            </Fragment>
                                            :
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: subscribeError
                                                }}
                                            />
                                        }
                                    </span>
                                </div>}
                                {
                                    (emailSubscribe === 'ERROR' && errorCode == 409) && <a
                                        className={'subscription-form-error-other-email'}
                                        onClick={this.handleError}
                                    >
                                    <span className={'subscription-form-chevron-left'}>
                                        <ChevronLeft/>
                                    </span>
                                        <span>
                                        Оформить на другой email
                                    </span>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                        :
                    (fullSize && deviceWidth >= 1008) ? <div className={'subscription-form-container'}>
                        <div className={'subscription-form-container-wrap'}>
                            <div className={'subscription-form-container-left'}>
                                <Tag
                                    dangerouslySetInnerHTML={{ __html: title }}
                                    className={'subscription-form-title'}
                                />

                                <p
                                    dangerouslySetInnerHTML={{ __html: text }}
                                    className={'subscription-form-text'}
                                />

                                {emailSubscribe === 'DEFAULT' && (
                                    <div className={'subscription-form-fields'}>
                                        <div className={'with-button-holder'}>
                                            <EmailField
                                                name="email"
                                                classes={{error: 'input__error subscription-form-email-error', root: 'subscription-form-email', input: 'subscription-form-email-input'}}
                                                placeholder={getMessage(words, 'com.s7.form', 'feedback.email')}
                                                value={ emailValue }
                                                onChange={ value => this.setState({ emailValue: value }) }
                                                error={ emailError }
                                                required
                                                onFocus={() => this.setState({ emailError: ''})}
                                            />

                                            {deviceWidth >= 768 &&
                                            this.renderTrailingButton()
                                            }
                                        </div>
                                        {this.renderAgreement()}
                                        {deviceWidth < 768 &&
                                        this.renderTrailingButton()
                                        }
                                        <Preloader
                                            isHidden={isPreloaderHidden}
                                            small
                                        />
                                    </div>
                                )}

                                {emailSubscribe === 'SUCCESS' && <div
                                    className={classnames({
                                        'subscription-form-status': true,
                                        'success': true,
                                    })}
                                >
                                    <span> {getMessage(words, 'com.s7.component.subscription.success')} </span>
                                </div>}

                                {emailSubscribe === 'ERROR' && <div
                                    className={classnames({
                                        'subscription-form-status': true,
                                        'error': true,
                                    })}
                                >
                                    <span>
                                        {isEmpty(subscribeError) ?
                                            <Fragment>
                                                {getMessage(words, 'com.s7.new.tablo.subscription.error')}
                                                <a className={'subscription-form-status-error-link'} onClick={this.handleError}>{getMessage(words, 'com.s7.new.tablo.subscription.errormore')}</a>
                                            </Fragment>
                                            :
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: subscribeError
                                                }}
                                            />
                                        }
                                    </span>
                                </div>}
                            </div>
                            <div className={'subscription-form-container-right'}>
                                <div className={'subscription-form-container-image-large'} />
                            </div>
                        </div>
                    </div>
                        :
                    <div className={'subscription-form-container'}>

                        <div className={'subscription-form-container-image'} />

                        <Tag
                            dangerouslySetInnerHTML={{ __html: title }}
                            className={'subscription-form-title'}
                        />

                        <p
                            dangerouslySetInnerHTML={{ __html: text }}
                            className={'subscription-form-text'}
                        />

                        {emailSubscribe === 'DEFAULT' && (
                            <div className={'subscription-form-fields'}>
                                <div className={'with-button-holder'}>
                                    <EmailField
                                        name="email"
                                        classes={{error: 'input__error subscription-form-email-error', root: 'subscription-form-email', input: 'subscription-form-email-input'}}
                                        placeholder={getMessage(words, 'com.s7.form', 'feedback.email')}
                                        value={ emailValue }
                                        onChange={ value => this.setState({ emailValue: value }) }
                                        error={ emailError }
                                        required
                                        onFocus={() => this.setState({ emailError: ''})}
                                    />

                                    {deviceWidth >= 768 &&
                                    this.renderTrailingButton()
                                    }
                                </div>
                                {this.renderAgreement()}
                                {deviceWidth < 768 &&
                                this.renderTrailingButton()
                                }
                                <Preloader
                                    isHidden={isPreloaderHidden}
                                    small
                                />
                            </div>
                        )}

                        {emailSubscribe === 'SUCCESS' && <div
                            className={classnames({
                                'subscription-form-status': true,
                                'success': true,
                            })}
                        >
                            <span> {getMessage(words, 'com.s7.component.subscription.success')} </span>
                        </div>}

                        {emailSubscribe === 'ERROR' && <div
                            className={classnames({
                                'subscription-form-status': true,
                                'error': true,
                            })}
                        >
                            <span>
                                {isEmpty(subscribeError) ?
                                    <Fragment>
                                        {getMessage(words, 'com.s7.new.tablo.subscription.error')}
                                        <a className={'subscription-form-status-error-link'} onClick={this.handleError}>{getMessage(words, 'com.s7.new.tablo.subscription.errormore')}</a>
                                    </Fragment>
                                    :
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: subscribeError
                                        }}
                                    />
                                }
                            </span>
                        </div>}
                    </div>
                }

            </form>
        )
    }
}

Subscription.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
    confirmCheckbox: PropTypes.bool,
    gaCategory: PropTypes.string,
    gaFrom: PropTypes.string,
    onSubmit:PropTypes.func,
    titleLevel: PropTypes.number,
    cssClasses: PropTypes.string,
    btnCssClasses:  PropTypes.string,
    dataTest:  PropTypes.string,
    fullSize: PropTypes.bool
};

Subscription.defaultProps = {
    text: '',
    title: '',
    cssClasses: '',
    btnCssClasses: '',
    confirmCheckbox: false,
    titleLevel: 3,
    onSubmit: () => {},
    dataTest: '',
    fullSize: false
};

export default connect(mapStateToProps)(injectIntl(Subscription));